export default __webpack_public_path__ + "static/media/holistic_qip.6cbb9842.png";